import React from 'react';
import { IconButton, Snackbar, SnackbarCloseReason, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { SNACKBAR_DURATION } from '../../utils/constants';

const useStyles = makeStyles((theme) => ({
    success: {
        '& .MuiSnackbarContent-root': {
            backgroundColor: 'green',
        },
    },
    error: {
        '& .MuiSnackbarContent-root': {
            backgroundColor: 'red',
        },
    },
}));

interface CustomSnackbarProps {
    open: boolean;
    message: string;
    mode?: 'success' | 'error';
    onClose: (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => void;
}

const CustomSnackbar: React.FC<CustomSnackbarProps> = ({ open, message, mode = 'success', onClose }) => {
    const classes = useStyles();

    const action = (
        <React.Fragment>
            {/* <Button color="secondary" size="small" onClick={handleClose}>
                UNDO
            </Button> */}
            <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <Snackbar
            open={open}
            onClose={onClose}
            message={message}
            className={classes[mode]}
            autoHideDuration={SNACKBAR_DURATION}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            action={action}
        />
    );
};

export default CustomSnackbar;
